import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import React from 'react';
import './EmbeddedImage.scss';

export const EmbeddedImage = ({ node, forceInline }) => {
    return (
        <figure
            className={`embedded-image themed-container ${node.field_theme ? node.field_theme : ``}`}
        >
            <div className={`${
                forceInline ? `inline` : `kite-container`
            }`}>
                <GatsbyImage
                    image={getImage(
                        node.relationships?.field_media?.relationships
                            ?.field_media_image?.localFile
                    )}
                    alt={
                        node.relationships?.field_media?.field_media_image?.alt
                            ? node.relationships?.field_media?.field_media_image
                                ?.alt
                            : ``
                    }
                />
                {node.field_subtitle && (
                    <figcaption>{node.field_subtitle}</figcaption>
                )}
            </div>
        </figure>
    );
};
